var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewPost"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('viewedPosts'))+" ")]),_c('div',{staticClass:"content"},[_vm._l((_vm.positionList),function(item){return _c('div',{key:item.id},[_c('viewPostItem',{attrs:{"item":item}})],1)}),(_vm.positionList.length === 0)?_c('noDataImg'):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }